<template>
  <div>
    <el-container class="admin-container">
      <AdminMenu></AdminMenu>
      <el-container>
        <AdminHeader></AdminHeader>
        <el-main class="admin-main">
          <div class="main-content">
            <router-view ref="view"></router-view>
          </div>
        </el-main>
        <AdminFooter ref="footer"></AdminFooter>
      </el-container>
    </el-container>
  </div>
</template>

<script>
  import "@/assets/css/common/common.css"
  import "@/assets/css/home/index.css"
  import AdminHeader from "@/components/common/header"
   import AdminFooter from "@/components/common/footer";
  import AdminMenu from "@/components/common/menu"
  export default {
    name: 'index',
    components: {
      AdminHeader,
       AdminFooter,
      AdminMenu
    },
    data() {
      return {
      };
    },
    methods: {
      queryArea(item,lng,lat){
        this.$refs.view.queryArea(item,lng,lat)
      },
    },
    created() {
      this.onUrl = this.$route.path
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue